import React from "react";
import { PageHeader } from "..";
import "../styles/pageLayout.style.css";
import { Breadcrumb } from "shared/components/Breadcrumb";

export const PageLayout = ({
  children,
  breadcrumb = [],
  titleEndComponent = null,
  title = "",
  isScrollable = true,
  isBreadCrumbsMarginRequired = true,
  isFullWidthContainer = true,
  isRowRequired = true,
  isBreadCrumbsRequired = true,
  isPageHeaderRequired = !!title || !!titleEndComponent,
  isBreadCrumbsPaddingRequired = true,
  subTitle = null,
  isAssessmentHeading = false,
  isPageEmpty = false
}) => {
  return (
    <>
      <section
        className={`main-page-wrapper ${isBreadCrumbsPaddingRequired ? "" : "pt-0"
          } ${isAssessmentHeading ? "page-wrapper-assessment-heading" : ""} ${isPageEmpty ? "empty-page-reduce-height" : ""}`}
      >
        <Breadcrumb
          title={title}
          breadcrumb={breadcrumb}
          isBreadCrumbsMarginRequired={isBreadCrumbsMarginRequired}
          isBreadCrumbsRequired={isBreadCrumbsRequired}
        />
        {isPageHeaderRequired && (
          <div className="container">
            <div className="row">
              <PageHeader
                isPageEmpty={isPageEmpty}
                titleEndComponent={titleEndComponent}
                title={title}
                subTitle={subTitle}
              />
            </div>
          </div>
        )}
        <div
          className={
            isFullWidthContainer ? `container ${(!isPageHeaderRequired && !isPageEmpty) ? "pb-3 pt-4" : ''}` : "container-fluid px-0"
          }
        >
          <div className={isRowRequired ? "row" : ""}>
            <div className={isScrollable ? "layout-scrollable" : ""}>
              {children}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
